
export default class GoogleDrive {
    static file_url(file_id,file_name="") {
        if (file_id){
            let origin = window.location.origin;
            let url = origin + "/api/gcs_download/"+file_id + (file_name!=""?"?d="+file_name:"");
            // let url = origin + "/api/image/"+file_id;
            // console.log(url)
            return url;
        }else{
            return file_id
        }        
        // console.log(url)
        // url = 'http://drive.google.com/uc?export=view&id=' + file_id;
    }
    static getDownloadUrl(file_id,file_name=""){
        if (file_id){
            let origin = window.location.origin;
            let url = origin + "/api/gcs_download/"+file_id + (file_name!=""?"?d="+file_name:"");
            // console.log(url)
            return url;
        }else{
            return file_id
        }
        // return "https://drive.google.com/uc?export=download&id="+file_id
    }
    static ThumnailUrl(file_id) {
        let url = 'https://drive.google.com/thumbnail?id=' + file_id;
        return url;
    }
    static getFormatUrl(sheet_id){
        return "https://docs.google.com/spreadsheets/d/"+sheet_id
    }
    static getOpenUrl(file_id){
        return 'https://drive.google.com/open?id=' + file_id;;
    }
}